import { Quote } from "lucide-react";
import "./index.css";
import ceoPic from "../../assets/images/directors/director_pic1.png";

export default function CEOMessage() {
  return (
    <div className="moc-page">
      <div className="moc-inner">
        <div className="moc-eyebrow"><span className="moc-dash" />FROM THE DESK<span className="moc-dash" /></div>
        <h1 className="moc-title">MESSAGE FROM THE <span>CEO</span></h1>
        <span className="moc-title-underline" />

        <div className="moc-card">
          {/* CEO profile */}
          <div className="moc-profile">
            <div className="moc-img-frame">
              <img src={ceoPic} alt="Muhammad Hammad Arshad" className="moc-img" />
            </div>
            <div className="moc-profile-info">
              <h2 className="moc-name">MUHAMMAD HAMMAD ARSHAD</h2>
              <div className="moc-position">Chief Executive Officer</div>
            </div>
          </div>

          {/* message */}
          <div className="moc-message">
            <Quote className="moc-quote" size={44} />
            <p className="moc-text">Dear Valued Stakeholders,</p>
            <p className="moc-text">
              Our vision at Orbit Securities Private Limited (OSPL) is to become
              Pakistan’s preferred stock market broker. We are committed to
              providing you, our clients, with the optimal environment to enhance
              your trading experience and boost your performance.
            </p>
            <p className="moc-text">
              We strive to provide our valued clients with actionable ideas. As a
              client of OSPL, your decision to trade with us entitles you to the
              best trading conditions at all times. We constantly deliver
              top-quality services including execution, settlement, research, and
              risk management to enhance your trading experience.
            </p>
            <p className="moc-text">
              As a capital market player, you need to have confidence in your
              broker and access to value-adding market insight to protect and grow
              your investment. OSPL fully meets these requirements. We have
              valuable brand equity in the local market that has been recognized
              by our valued clients.
            </p>
            <p className="moc-text">
              At OSPL, we adhere to the saying by Mian Hammad “People of
              accomplishment rarely sit back and let things happen to them. They
              go out and make things happen.” As testament to this statement, Retail
              clients are serviced through OSPL Trade, Pakistan’s efficient online
              trading platform. A professional in-house research team provides
              premium fundamental and technical analysis to guide our clients in
              their decision-making process.
            </p>
            <p className="moc-text">
              I invite you to browse our website and discover who we are and learn
              more fully how OSPL can advance your investment and business needs.
              In this spirit, thank you for selecting OSPL as your broker
              of choice and all the best in your future trading.
            </p>

            <div className="moc-signature">
              <p className="moc-sign-name">MUHAMMAD HAMMAD ARSHAD</p>
              <p className="moc-sign-position">Chief Executive Officer</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
